export const getExposureLabel = (
  code: string | undefined | null,
): string | undefined | null => {
  switch (code) {
    case 'N':
      return 'Nord';
    case 'S':
      return 'Sud';
    case 'E':
      return 'Est';
    case 'O':
      return 'Ouest';
    case 'NE':
      return 'Nord-Est';
    case 'SE':
      return 'Sud-Est';
    case 'SO':
      return 'Sud-Ouest';
    case 'NO':
      return 'Nord-Ouest';
    default:
      return null;
  }
};
